import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchJobsForScope,
  selectScopeJobs,
} from "../../../redux/slices/job-scope-slice";
import {
  fetchRoundsForJob,
  selectRoundsForJob,
} from "../../../redux/slices/question-bank-slice";

export default function JobRoundPicker({
  jobId,
  interviewRound,
  onJobChange,
  onRoundChange,
}) {
  const dispatch = useDispatch();
  const jobs = useSelector(selectScopeJobs);
  const rounds = useSelector(selectRoundsForJob(jobId));

  // Refresh the jobs list every time the picker mounts (i.e. each visit to
  // /admin/question-bank). The Redux cache stays populated during the
  // in-flight fetch, so the dropdown options remain visible — they just get
  // replaced with the fresh response once it lands.
  useEffect(() => {
    dispatch(fetchJobsForScope());
  }, [dispatch]);

  useEffect(() => {
    if (jobId != null) dispatch(fetchRoundsForJob({ jobId }));
  }, [dispatch, jobId]);

  return (
    <div style={row}>
      <div style={{ flex: 1 }}>
        <div style={label}>Job</div>
        <select
          value={jobId ?? ""}
          onChange={(e) => {
            const v = e.target.value;
            onJobChange(v ? Number(v) : null);
            onRoundChange(""); // reset round when job changes
          }}
          style={select}
        >
          <option value="">— pick a job —</option>
          {jobs.map((j) => (
            <option key={j.id} value={j.id}>
              {j.name}
            </option>
          ))}
        </select>
      </div>
      <div style={{ flex: 1 }}>
        <div style={label}>Interview round</div>
        <select
          value={interviewRound ?? ""}
          onChange={(e) => onRoundChange(e.target.value || "")}
          disabled={!jobId || rounds.length === 0}
          style={{
            ...select,
            opacity: !jobId || rounds.length === 0 ? 0.5 : 1,
          }}
        >
          <option value="">
            {!jobId
              ? "Pick a job first"
              : rounds.length === 0
                ? "No rounds defined"
                : "— pick a round —"}
          </option>
          {rounds.map((r) => (
            <option key={r} value={r}>
              {r}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

const row = { display: "flex", gap: 12, marginBottom: 14, alignItems: "end" };
const label = {
  fontSize: 10,
  color: "#64748B",
  marginBottom: 4,
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: 0.4,
};
const select = {
  width: "100%",
  padding: "7px 10px",
  border: "1px solid #E2E8F0",
  borderRadius: 6,
  fontSize: 13,
  color: "#0F172A",
  outline: "none",
  background: "white",
  boxSizing: "border-box",
};
